// Slice 42 — feedback list/detail formatters.

export function fmtRelative(receivedAtMs: number, nowMs: number = Date.now()): string {
  const diff = Math.max(0, nowMs - receivedAtMs);
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  const week = Math.floor(day / 7);
  if (week < 4) return `${week}w ago`;
  const month = Math.floor(day / 30);
  if (month < 12) return `${month}mo ago`;
  return `${Math.floor(day / 365)}y ago`;
}

export function clamp(body: string, max = 140): string {
  if (body.length <= max) return body;
  return `${body.slice(0, max - 1)}…`;
}

export interface ParsedSystemInfo {
  os?: string;
  arch?: string;
  instanceCount?: number;
}

export function parseSystemInfo(raw: string | null | undefined): ParsedSystemInfo | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw) as ParsedSystemInfo;
    return v && typeof v === "object" ? v : null;
  } catch {
    return null;
  }
}
